<template>
  <div>
    <div
      v-if="legionnelStandard"
      :key="legionnelStandard.id"
      class="standard-family"
    >
      <div
        class="standard-block"
      >
        <div class="analysisType--container">
          <span
            class="analysisType--name"
          >{{ legionnelStandard.name[userLang] }}</span>
        </div>
        <div
          v-for="caption in captions"
          :key="caption"
          class="caption--item"
        >
          <div
            class="colored--block"
            :class="caption"
          />
          <div class="caption--intervention">
            <div v-if="caption === 'normal'">
              <span>{{ $t(`standards.labels.normal`) }}</span>
              <span>
                {{ `(&lt; ${legionnelStandard.norm.intervention ?
                  legionnelStandard.norm.intervention : '' } ${getTranslatedMeasureUnit(legionnelStandard.measureUnit)})` }}
              </span>
            </div>
            <div v-else-if="caption === 'intervention'">
              <span>{{ $t(`standards.labels.intervention`) }}</span>
              <span>{{ `(>= ${legionnelStandard.norm.intervention ?
                legionnelStandard.norm.intervention :''} ${$t('labWorkOrderTable.labels.and')}
              &lt; ${legionnelStandard.norm.risk ?
              legionnelStandard.norm.risk : ''} ${getTranslatedMeasureUnit(legionnelStandard.measureUnit)})` }}</span>
            </div>
            <div v-else-if="caption === 'risk'">
              <span>{{ $t(`standards.labels.risk`) }}</span>
              <span>{{ `(>= ${legionnelStandard.norm.risk ?
                legionnelStandard.norm.risk : ''} ${getTranslatedMeasureUnit(legionnelStandard.measureUnit)})` }}</span>
            </div>
            <div>
              <em v-if="legionnelStandard.norm.notes">{{ legionnelStandard.norm.notes[caption][userLang] }}</em>
              <em v-else>-</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        legionnelStandard: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            filteredStandards: [],
            captions: ['normal', 'intervention', 'risk'],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
    },
    methods: {
        getTranslatedMeasureUnit(measureUnit = {}) {
            return measureUnit[this.userLang] || measureUnit[this.teamMainLang] || '';
        },
    },
};
</script>

<style lang="scss" scoped>
.standard-block {
  padding: 4px 7px;
  margin-bottom: 8px;
  width: 230px;
  &:last-of-type {
    border-bottom: 0;
  }
}
.analysisType--container {
  padding: 0px 17px 0px 27px; // 27px (17px for width and 10px for pading-left)
}
.analysisType--name {
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
}
.caption--item {
  min-height: 70px;
  margin-bottom: 15px;
  display: flex;
}
.colored--block {
  width: 17px;
  min-width: 17px;
  min-height: 70px;
    &.normal {
      background: #2A7113;
    }
    &.intervention {
      background: #C7A21B;
    }
    &.risk {
      background: #AD1C3F;
    }
}
.caption--intervention {
  word-break: break-word;
  padding-left: 10px;
  min-height: 70px;
  height: 100%;
  width: 100%;
}
</style>
